export class RepairsUpdatesCommentsDeleteRequest {
  commentId!: string

  constructor(commentId: string) {
    this.commentId = commentId
  }
}
